import React, {useContext, useState, useEffect} from "react"

import Button from "../../../../common/Button";
import {api} from "../../../../../api/api";
import {getErrorByStatus, getState, nowStamp, storeState} from "../../helpers";
import TranslationContext from "../../../../../context/TranslationContext";
import UserContext from "../../../../../context/UserContext";
import PhoneInsertField from "../../PhoneInput"
import InsertField from "../../../../common/InsertField";
import Call800Action from "../Call800Action"

const SmsAction = (props) => {
    const {getTranslation} = useContext(TranslationContext)
    const {setApiWait} = useContext(UserContext)
    const [phase1Success, setPhase1Success] = useState(false)

    const [otp, setOtp] = useState("")
    const [phone, setPhone] = useState("")
    const [error, setError] = useState("")
    const [errorMsg, setErrorMsg] = useState("")
    const [backupAction, setBackupAction] = useState(false)    
    const [renderNextBtn, setRenderNextBtn] = useState(false)  

    const formatedPhone = (phone) => {
        return phone
            .replaceAll("(", "")
            .replaceAll(")", "")
            .replaceAll("-", "")
            .replaceAll(" ", "")
    }

    useEffect(() => {
        if (error !== "") {
            if (getTranslation(error)!=="") {setErrorMsg(getTranslation(error))} else {setErrorMsg(error)}  
        }
    },[getTranslation, error])
    
    useEffect(()=>{
        // const n = nowStamp()
        const phone = getState("user_phone")
        const smsExpire = getState("smsExpire")
        const smsStampExpire = parseInt(smsExpire, 10)
        if (phone !== "" &&  nowStamp() < smsStampExpire ) {
            // debugger
            setError(getTranslation('info_reply_sms').split("[MIN]").join(`${smsStampExpire-nowStamp()}`))
            setPhone(phone)
            setPhase1Success(true)
        }
    },[])
    const failRequest = () => {
        setBackupAction(true)
    }

    const requestSmsOnPhone = () => {
        const reg_exp_phone = /^\d{10,15}$/;
        if (phone === "") {
            setError("no_num")
        } else if (!reg_exp_phone.test(phone)) {
            setError("wrong_num")
        // } else if (phone.length > 12) {
        //     setError("Sorry we can not send SMS message on this phone number. Please click 'Continue' for complete registration with call. Call is FREE!")
        //     setRenderNextBtn(true)
        } else {
            storeState("user_phone", formatedPhone(phone))
            setApiWait(true)
            api.getOtpSMS(formatedPhone(phone))
                .then(res => {
                    if (res.data.status === "success") {
                        setError("")
                        setPhase1Success(true)
                        storeState("smsExpire", nowStamp() + parseInt(res.data.timeout))
                        if (res.data.notify !== "") {
                            // console.log(res.data.notify)
                        }
                    } else if (res.data.message === "not_expired") {
                        setError(getTranslation('info_reply_sms').split("[MIN]").join(`${res.data.timeout}`))
                        setPhase1Success(true)

                        let notify = res.data.timeout
                        // let notify = 10
                        const notifyCount = setInterval(() => {
                            if (notify === 0 || notify < 0) {
                                clearInterval(notifyCount)
                                setError("")
                                setPhase1Success(false)
                            } else {
                                setError(getTranslation('info_reply_sms').split("[MIN]").join(`${notify}`))
                                notify--
                            }
                        }, 1000)
                    }
            }).catch(err => {
                getErrorByStatus(err.response.status, setError, getTranslation)

            }).finally( () => {
                setApiWait(false)}
            )
        }
    }

    const otpChangeHandler = (evt) => {
        setOtp(v => {
            return evt.target.validity.valid
                ? evt.target.value
                : v
        })
    }

    const checkOtpWithPhone = () => {
        if (otp === "") {
            setError('info_check')
        } else {
            setError("")
            setApiWait(true)

            api.getOtpChallenger(formatedPhone(phone), otp).then(res => {
                if (res.status === 200 && res.data.status === "ok") {
                    props.setAccess(true)
                }
            }).catch(err => {
                if (err.response.status === 400) {
                    setError('err_check')
                    return
                }
                getErrorByStatus(err.response.status, setError, getTranslation)
            }).finally( () => {
                setApiWait(false)}
            )
        }
    }

    if (backupAction) {
        return <Call800Action userPhone={phone} setAccess={props.setAccess} handlerBackBtn = {props.handlerBackBtn} />
    }

    return (
        <div className="d-flex flex-column">
            <span style={{marginBottom: "1rem"}} data-id_phrase="no_num" >{getTranslation("no_num")}</span>
            <PhoneInsertField 
                className="btn element-border"
                phoneSetter={setPhone}
                turnOffStatus={phase1Success}
            />
            {
                (phase1Success) 
                ? <>
                    <p className="main-font-style" data-id_phrase="info_succ_sms">{getTranslation("info_succ_sms")}</p>
                    <span style={{marginBottom: "1rem"}} data-id_phrase="sms_code_text" >{getTranslation("sms_code_text")}</span>
                    <InsertField
                        type="password"
                        value={otp}
                        onChange={otpChangeHandler}
                        pattern='[0-9]*'
                    />
                    {
                        (error !== "") && <p data-id_phrase={error} >{errorMsg}</p>
                    }
                    <Button
                        onClick={checkOtpWithPhone}
                        text={"Активировать"}
                        idPhrase={"btn_acc"}
                    />
                </> 
                : <>
                    {(error !== "") && <p data-id_phrase={error} >{errorMsg}</p>}
                    <span style={{marginBottom: "1rem"}} data-id_phrase="info_sms" >{getTranslation("info_sms")}</span>
                    <SendMessageBtn handlerSmsSend = {requestSmsOnPhone} handlerFail={failRequest} failStatus={renderNextBtn} />
                </>
            }
            <Button onClick={props.handlerBackBtn} text={"Назад"} idPhrase={"back"}/>
        </div>
    )
}
const SendMessageBtn = ({handlerSmsSend, handlerFail, failStatus }) => {
    if (failStatus) {
        return <Button
            onClick={handlerFail}
            text={"Continue"}
            idPhrase={"next"}
        />
    }
    return <Button
        onClick={handlerSmsSend}
        text={"Получить Код"}
        idPhrase={"btn_sms"}
        />
}
export default SmsAction